import { render, staticRenderFns } from "./FundInfoModal.vue?vue&type=template&id=1f50bb96&scoped=true&"
import script from "./FundInfoModal.vue?vue&type=script&lang=js&"
export * from "./FundInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./FundInfoModal.vue?vue&type=style&index=0&id=1f50bb96&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f50bb96",
  null
  
)

export default component.exports